import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=a632eb40&"
import script from "./Submission.vue?vue&type=script&lang=js&"
export * from "./Submission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a632eb40')) {
      api.createRecord('a632eb40', component.options)
    } else {
      api.reload('a632eb40', component.options)
    }
    module.hot.accept("./Submission.vue?vue&type=template&id=a632eb40&", function () {
      api.rerender('a632eb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/assignmentBin/Submission.vue"
export default component.exports